// Default Libraries
import Immutable from 'immutable';
import { createStore, getActionIds } from '../helpers/redux';

// Listeners
import { ToastActions } from '../actions/toast';

//Listener Variables
const toastActions = getActionIds(ToastActions);

// Initial State
const initialState = Immutable.fromJS({
  toasts: [],
});

export const toasts = createStore(initialState, {
  [toastActions.createToast]: (state, action) => {
    return state.merge({
      toasts: state.get('toasts').push(action.toast),
    });
  },
  [toastActions.deleteToast]: (state, action) => {
    return state.merge({
      toasts: state.get('toasts').shift(),
    });
  },
});



// WEBPACK FOOTER //
// ./src/reducers/toasts.js